module.exports = __webpack_public_path__ + "img/4_2.30840c7b.png";